import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11dfd9a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "packages-announcement-modal__image",
  src: "/assets/images/tariff/packages-announcement.png",
  alt: "Иллюстрация"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "packages-announcement-modal__text mb-3" }, " Теперь выбрать подходящий вариант стало ещё проще. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "packages-announcement-modal__accent mb-3" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "packages-announcement-modal__list" }, [
    /*#__PURE__*/_createElementVNode("li", null, "Оплата сразу на 3, 6 или 12 месяцев."),
    /*#__PURE__*/_createElementVNode("li", null, "Чем больше срок — тем выгоднее стоимость."),
    /*#__PURE__*/_createElementVNode("li", null, "Или выбирайте отдельные функции с ежемесячной оплатой.")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "packages-announcement-modal__text mb-0" }, " Подключайте готовые пакеты или оплачивайте только те функции, которыми действительно пользуетесь. ", -1))

import { ref } from 'vue';
import TariffNotificationModal from '../TariffNotificationModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PackagesAnnouncementModal',
  emits: ["hidden", "confirm"],
  setup(__props, { expose: __expose, emit: __emit }) {

// Модалка-анонс запуска пакетов на 3/6/12 месяцев (FINCH-2446).
// Иллюстрация лежит внутри default-слота, а не передаётся через imageUrl:
// шелл рендерит imageUrl колонкой слева, а по макету картинка идёт сверху по центру.
const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

const emit = __emit;

function onConfirm() {
    emit('confirm');
}

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

__expose({
    show: showModal,
    hide: hideModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TariffNotificationModal, {
    ref_key: "modalRef",
    ref: modalRef,
    title: "В Finch появились пакеты 3, 6 и 12 месяцев",
    onButtonClick: onConfirm,
    onHidden: _cache[0] || (_cache[0] = ($event: any) => (emit('hidden'))),
    "button-text": "Подробнее",
    "max-width": 450
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4
    ]),
    _: 1
  }, 512))
}
}

})